export default __webpack_public_path__ + "static/media/4n.e692a18d.svg";